import script from "./manufacture.vue?vue&type=script&setup=true&lang=js"
export * from "./manufacture.vue?vue&type=script&setup=true&lang=js"

import "./manufacture.vue?vue&type=style&index=0&id=41df884d&lang=scss"

const __exports__ = script;

export default __exports__